import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getCaptchaToken = (state: IRootState) => state.captcha.captchaToken;
export const getCaptchaIsFetching = (state: IRootState) => state.captcha.isFetching;
export const getCaptchaError = (state: IRootState) => state.captcha.error;
export const getCaptchaIsActive = (state: IRootState) => state.captcha.isActive;
export const getCaptchaImage = (state: IRootState) => state.captcha.image;
export const getCaptchaActionAfterLoad = (state: IRootState) => state.captcha.actionAfterTokenLoad;
export const getCaptchaAudio = (state: IRootState) => state.captcha.audio;
